import { Component, OnInit } from '@angular/core';
import { ModuloEnum } from '../../../shared/enums/modulo.enum';
import { FuncionalidadeEnum } from '../../../shared/enums/funcionalidade.enum';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { EmpresaGrupoService } from '../../../shared/services/apis/usuario/empresa-grupo.service';
import { AlertService, AlertType } from '../../../shared/services/alert.service';
import { PermissaoEnum } from '../../../shared/enums/permissao.enum';
import { ListaEmpresaGrupoResponse } from '../../../shared/services/responses/usuario/lista-empresa-grupo.response';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { CnpjPipe } from '../../../shared/pipes/cnpj.pipe';

import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { EmptyListComponent } from '../../../shared/components/empty-list/empty-list.component';
import { LoadingBoxComponent } from '../../../shared/components/loading-box/loading-box.component';
import { MenuComponent } from '../../../shared/components/menu/menu.component';
import { TemPermissaoDirective } from '../../../shared/directives/habilita-por-permissao.directive';
import { EmpresaGrupoStruct } from '../../../shared/services/structs/usuario/empresa-grupo.struct';

@Component({
  selector: 'app-empresa-grupo-lista',
  templateUrl: './empresa-grupo-lista.component.html',
  styleUrl: './empresa-grupo-lista.component.css',
  imports: [
    MenuComponent,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    FormsModule,
    MatButtonModule,
    MatIconModule,
    MatProgressSpinnerModule,
    MatTableModule,
    LoadingBoxComponent,
    RouterModule,
    EmptyListComponent,
    MatTooltipModule,
    MatSelectModule,
    MatSlideToggleModule,
    TemPermissaoDirective,
    CnpjPipe,
  ],
})
export class EmpresaGrupoListaComponent implements OnInit {
  public moduloEnum: ModuloEnum;
  public funcionalidadeEnum: FuncionalidadeEnum;

  constructor(
    private formBuilder: FormBuilder,
    private empresaGrupoService: EmpresaGrupoService,
    private alertService: AlertService
  ) {
    this.moduloEnum = ModuloEnum.Implantacao;
    this.funcionalidadeEnum = FuncionalidadeEnum.Implantacao_GrupoEmpresa;
  }

  public model: FormGroup;
  public _isLoading: boolean = false;
  public _listaEmpresaGrupo: ListaEmpresaGrupoResponse | undefined;
  public displayedColumns: string[] = [
    'idEmpresaGrupo',
    'nomeEmpresaGrupo',
    'nomeEmpresaPrincipal',
    'cnpj',
    'action-edit',
  ];
  public _dataSource = new MatTableDataSource<EmpresaGrupoStruct>();
  public _paginaAtual: number = 0;
  public _ultimaPagina: boolean = false;
  public _PermissaoEnum = PermissaoEnum;

  ngOnInit(): void {
    this.model = this.formBuilder.group({
      nomeEmpresaGrupo: [''],
      nomeEmpresaPrincipal: [''],
    });

    this.pesquisar();
  }

  private pesquisar(): void {
    if (this.model.invalid || this._isLoading === true) {
      return;
    }

    this._isLoading = true;
    const nomeGrupo = this.model.get('nomeEmpresaGrupo')?.value || '';
    const nomeEmpresa = this.model.get('nomeEmpresaPrincipal')?.value || '';

    this.empresaGrupoService.get(nomeGrupo, nomeEmpresa, this._paginaAtual).subscribe({
      next: (response: ListaEmpresaGrupoResponse) => {
        this._isLoading = false;
        if (response.isError) {
          this.alertService.show('Erro', response.errorDescription, AlertType.error);
          return;
        }

        this._ultimaPagina = true;

        if (!this._listaEmpresaGrupo) {
          this._listaEmpresaGrupo = response;
          this._ultimaPagina = false;
        } else if (response.listaEmpresaGrupo?.length > 0) {
          this._listaEmpresaGrupo.listaEmpresaGrupo.push(...response.listaEmpresaGrupo);
          this._ultimaPagina = false;
        }
        this._dataSource.data = this._listaEmpresaGrupo.listaEmpresaGrupo;
      },
      error: error => {
        this.alertService.show('Erro inesperado', error.message, AlertType.error);
        this._isLoading = false;
      },
    });
  }

  proximaPagina(): void {
    this._paginaAtual = this._paginaAtual + 1;
    this.pesquisar();
  }

  clickPesquisar(): void {
    this._paginaAtual = 0;
    this._listaEmpresaGrupo = undefined;
    this.pesquisar();
  }
}
